import _ from 'lodash';
import { EditStore, EditStoreProps } from '@/main/store/@types/edit.d';
import { END_LOADING, ERROR, START_LOADING } from '@/main/store/listEditTypes';

import { Edit, LocalState, ProvozovnaDropdownList } from './state';
import { types } from '../types';
import { apiProvider } from '../../api';
import { DMS_MODULE } from '../../constants';

type State = EditStore<Edit, ProvozovnaDropdownList, LocalState, {}, EditStoreProps>;
type VuexProps = { commit: any, dispatch: any, state?: State };

export const actions = {
	async [types.actions.GET_PROVOZOVNA_TABLE_SCHEMA_AND_ROWS]({ commit, dispatch, state }: VuexProps, tableName: string) {
		if (!_.has(state!.localState, `${tableName}Table`)) {
			return;
		}

		const filter = {
			ProvozovnaId: state!.edit.ProvozovnaId!,
			wantRows: true,
		};
		const stateTableName = _.isNil((state!.localState as Record<string, any>)[`${tableName}Table`]) ? undefined : `${tableName}Table`;
		try {
			commit(START_LOADING, stateTableName);
			const { data } = await apiProvider.getProvozovnaTableSchemaAndRows(filter, tableName);
			commit(types.mutations.SET_PROVOZOVNA_TABLE, { data, tableName });
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING, stateTableName);
		}
	},
};
